// extracted by css-extract-rspack-plugin
module.exports =  {"root":"NoOpportunitySelected__root___FnYX6","content":"NoOpportunitySelected__content___gFXns"};